import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-userlist',
  templateUrl: './userlist.component.html',
  styleUrls: ['./userlist.component.scss']
  })
export class UserlistComponent implements OnInit {

  constructor() { }
  @Input()
  public avatars: string[] = [];

  public avatarListExpanded = false;
  ngOnInit(): void {
  }

}
